import React from 'react'
import { Name } from '@src/containers/UtmGenerator/helpers'
import { getId } from '@src/containers/UtmGenerator/helpers'

export const TableData = {
  direct: [
    {
      id: getId(),
      label: 'Параметр',
      description: <>Описание</>
    },
    {
      id: getId(),
      label: '{ad_id}, {banner_id}',
      description: <>Идентификатор объявления</>
    },
    {
      id: getId(),
      label: '{addphrases}',
      description: (
        <>
          Объявление показано по&nbsp;дополнительной релевантной фразе?
          <ul>
            <li>yes&nbsp;&mdash; показ по&nbsp;дополнительной релевантной фразе </li>
            <li>no&nbsp;&mdash; показ по&nbsp;исходной фразе</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{addphrasestext}',
      description: (
        <>
          Текст дополнительной релевантной фразы:
          <ul>
            <li>текст фразы&nbsp;&mdash; при показе по&nbsp;дополнительной релевантной фразе</li>
            <li>none&nbsp;&mdash; при показе по&nbsp;исходной фразе</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{campaign_type}',
      description: (
        <>
          Тип кампании:
          <ul>
            <li>type1&nbsp;&mdash; текстово-графические объявления</li>
            <li>type2&nbsp;&mdash; реклама мобильных приложений</li>
            <li>type3&nbsp;&mdash; динамические объявления</li>
            <li>type4&nbsp;&mdash; смарт-баннеры</li>
            <li>type6&nbsp;&mdash; баннер в&nbsp;поиске</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{campaign_id}',
      description: <>Идентификатор рекламной кампании</>
    },
    {
      id: getId(),
      label: '{creative_id}',
      description: <>Идентификатор креатива из&nbsp;конструктора</>
    },
    {
      id: getId(),
      label: '{device_type}',
      description: (
        <>
          Тип устройства, на&nbsp;котором показано объявление:
          <ul>
            <li>desktop&nbsp;&mdash; компьютер</li>
            <li>mobile&nbsp;&mdash; мобильное</li>
            <li>tablet&nbsp;&mdash; планшет</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{gbid}',
      description: <>Идентификатор группы</>
    },
    {
      id: getId(),
      label: '{keyword}',
      description: (
        <>
          Ключевая фраза, по&nbsp;которой было показано объявление (текстово-графическое или реклама
          мобильных приложений) (без минус-слов)
        </>
      )
    },
    {
      id: getId(),
      label: '{phrase_id}',
      description: (
        <>
          Идентификатор ключевой фразы для текстово-графических объявлений или рекламы мобильных
          приложений
        </>
      )
    },
    {
      id: getId(),
      label: '{retargeting_id}',
      description: (
        <>
          Идентификатор условия нацеливания на&nbsp;аудиторию, связывающего группу объявлений
          с&nbsp;условиями подбора аудитории или интересами к&nbsp;мобильным приложениям
        </>
      )
    },
    {
      id: getId(),
      label: '{coef_goal_context_id}',
      description: <>Идентификатор корректировки ставок для условия подбора аудитории</>
    },
    {
      id: getId(),
      label: '{interest_id}',
      description: <>Идентификатор интереса к&nbsp;мобильным приложениям</>
    },
    {
      id: getId(),
      label: '{adtarget_name}',
      description: <>Условие нацеливания динамического объявления</>
    },
    {
      id: getId(),
      label: '{position}',
      description: (
        <>
          Точная позиция объявления в&nbsp;блоке. Передает только номер позиции, по&nbsp;которому
          невозможно определить тип блока, где показано объявление. Используйте вместе&nbsp;с&nbsp;
          {`{position_type}`}.
          <ul>
            <li>номер позиции в&nbsp;блоке (например, 1)</li>
            <li>0&nbsp;&mdash; объявление показано в&nbsp;сетях (РСЯ или внешних)</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{position_type}',
      description: (
        <>
          Тип блока на&nbsp;странице результатов поиска Яндекса:
          <ul>
            <li>premium&nbsp;&mdash; премиум-показы</li>
            <li>other&nbsp;&mdash; блок справа или блок внизу</li>
            <li>none&nbsp;&mdash; объявление показано в&nbsp;сетях (РСЯ или внешних)</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{source}',
      description: (
        <>
          Место показа:
          <ul>
            <li>домен площадки&nbsp;&mdash; при показе в&nbsp;сетях (РСЯ или внешних)</li>
            <li>none&nbsp;&mdash; при показе в&nbsp;поиске Яндекса</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{source_type}',
      description: (
        <>
          Тип площадки, на&nbsp;которой показано объявление:
          <ul>
            <li>search&nbsp;&mdash; поиск</li>
            <li>context&nbsp;&mdash; сети</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      label: '{region_name}',
      description: <>Регион, в&nbsp;котором было показано объявление</>
    },
    {
      id: getId(),
      label: '{region_id}',
      description: <>Идентификатор региона, в&nbsp;котором было показано объявление</>
    }
  ],
  googleAds: [
    {
      id: getId(),
      label: 'Параметр',
      description: <>Что подставится вместо {'{параметра}'}</>
    },
    {
      id: getId(),
      label: '{adgroupid}',
      description: (
        <>
          Идентификатор группы объявлений&nbsp;&mdash; помогает отследить группу, в&nbsp;которую
          входит показанное объявление. Параметр можно использовать, если настроено отслеживание
          на&nbsp;уровне аккаунта или кампании
        </>
      )
    },
    {
      id: getId(),
      label: '{adposition}',
      description: (
        <>
          Позиция объявления на&nbsp;странице. Например, 1t2&nbsp;значит, что объявление было
          показано на&nbsp;первой странице (первая цифра) над результатами поиска (t&nbsp;значит
          top) на&nbsp;второй позиции (последняя цифра)
        </>
      )
    },
    {
      id: getId(),
      label: '{campaignid}',
      description: (
        <>
          Идентификатор кампании&nbsp;&mdash; помогает отследить кампанию, к&nbsp;которой относится
          показанное объявление. Параметр можно использовать, если настроено отслеживание
          на&nbsp;уровне аккаунта
        </>
      )
    },
    {
      id: getId(),
      label: '{creative}',
      description: <>Уникальный идентификатор объявления</>
    },
    {
      id: getId(),
      label: '',
      description: <></>
    },
    {
      id: getId(),
      label: '{device}',
      description: (
        <>
          Тип устройства, с&nbsp;которого кликнули по&nbsp;объявлению: m&nbsp;&mdash; мобильное,
          t&nbsp;&mdash; планшет, c&nbsp;&mdash; компьютер
        </>
      )
    },
    {
      id: getId(),
      label: '{feeditemid}',
      description: <>Идентификатор расширения, по&nbsp;которому кликнул пользователь</>
    },
    {
      id: getId(),
      label: '{keyword}',
      description: (
        <>
          Ключевое слово, по&nbsp;которому было показано объявление в&nbsp;поисковой сети, или
          наиболее близкое к&nbsp;ключевому слово для показов в&nbsp;контекстно-медийной сети
        </>
      )
    },
    {
      id: getId(),
      label: '{loc_interest_ms}',
      description: (
        <>
          Идентификатор местоположения из&nbsp;поискового запроса пользователя. Работает только
          в&nbsp;кампаниях для тех, кто интересуется целевыми местоположениями
        </>
      )
    },
    {
      id: getId(),
      label: '{loc_physical_ms}',
      description: (
        <>
          Идентификатор географического местоположения пользователя, который кликнул
          по&nbsp;объявлению. Работает только в&nbsp;объявлениях, которые показываются
          в&nbsp;целевых местоположениях
        </>
      )
    },
    {
      id: getId(),
      label: '{lpurl}',
      description: (
        <>
          Конечный URL. Экранируется: если ссылка содержит специальные символы ?, =, &quot;, #, \t,
          &rsquo; или пробел, то&nbsp;эти символы заменяются на&nbsp;другие, например, вместо
          &amp;&nbsp;подставляется %26. Исключение&nbsp;&mdash; случаи, когда {'{lpurl}'} указан
          в&nbsp;начале шаблона отслеживания
        </>
      )
    },
    {
      id: getId(),
      label: '{matchtype}',
      description: <>Тип соответствия ключевого слова, по&nbsp;которому было показано объявление</>
    },
    {
      id: getId(),
      label: '{merchant_id}',
      description: (
        <>
          Идентификатор аккаунта Google Merchant Center, к&nbsp;которому относится товарное
          объявление
        </>
      )
    },
    {
      id: getId(),
      label: '{placement}',
      description: <>Сайт, на&nbsp;котором пользователь кликнул по&nbsp;объявлению</>
    },
    {
      id: getId(),
      label: '{product_channel}',
      description: (
        <>
          Тип канала, через который продается товар. Например, online для интернет-магазинов
          и&nbsp;local для обычных розничных точек
        </>
      )
    },
    {
      id: getId(),
      label: '{product_country}',
      description: <>Страна, в&nbsp;которой продается товар</>
    },
    {
      id: getId(),
      label: '{product_id}',
      description: <>Идентификатор товара из&nbsp;фида данных Merchant Center</>
    },
    {
      id: getId(),
      label: '{product_language}',
      description: <>Язык, на&nbsp;котором описан товар в&nbsp;фиде данных Merchant Center</>
    },
    {
      id: getId(),
      label: '{product_partition_id}',
      description: <>Уникальный идентификатор группы товаров, к&nbsp;которой относится объявление</>
    },
    {
      id: getId(),
      label: '{store_code}',
      description: (
        <>
          Уникальный код магазина. Только для товаров местного ассортимента в&nbsp;торговых
          кампаниях. Максимальная длина&nbsp;&mdash; 60&nbsp;символов
        </>
      )
    },
    {
      id: getId(),
      label: '{targetid}',
      description: (
        <>
          Идентификатор ключевого слова (kwd), цели динамического поискового объявления (dsa), цели
          списка ремаркетинга (aud), сегмента товаров (pla) или сегмента группы отелей, вызывающий
          показ объявления. Если параметров много, они отображаются в&nbsp;таком порядке: aud, dsa,
          kwd, pla, hpi. Например, если добавить в&nbsp;группу объявлений список ремаркетинга
          с&nbsp;идентификатором 456 и&nbsp;настроить таргетинг на&nbsp;ключевые слова
          с&nbsp;идентификатором 123, параметр {'{targetid}'} будет выглядеть так: aud-456:kwd-123.
        </>
      )
    }
  ],
  vkAds: [
    {
      id: getId(),
      label: 'Параметр',
      description: <>Значение</>
    },
    {
      id: getId(),
      label: '{{advertiser_id}}',
      description: <>id&nbsp;рекламодателя</>
    },
    {
      id: getId(),
      label: '{{campaign_id}}',
      description: <>id&nbsp;группы объявлений</>
    },
    {
      id: getId(),
      label: '{{campaign_name}}',
      description: <>Название группы объявлений</>
    },
    {
      id: getId(),
      label: '{{banner_id}}',
      description: <>id&nbsp;баннера</>
    },
    {
      id: getId(),
      label: '{{geo}}',
      description: <>id&nbsp;региона, из&nbsp;которого был сделан переход</>
    },
    {
      id: getId(),
      label: '{{gender}}',
      description: <>Пол пользователя, который сделал переход</>
    },
    {
      id: getId(),
      label: '{{age}}',
      description: <>Возраст пользователя, который сделал переход</>
    },
    {
      id: getId(),
      label: '{{random}}',
      description: (
        <>
          Случайное число. Часто используется в&nbsp;ссылках (аудит-пикселях) для более точного
          подсчета показов. Принимаемые значения: Число. Пример:
          http://tag.com?utm_campaign=abc&amp;rnd={'{{ random }}'}
        </>
      )
    },
    {
      id: getId(),
      label: '{{impression_weekday}}',
      description: (
        <>
          День недели, в&nbsp;который произошел показ баннера. Используется в&nbsp;метке ссылки.
          Пример: mon, tue, sat
        </>
      )
    },
    {
      id: getId(),
      label: '{{impression_hour}}',
      description: (
        <>
          Час, в&nbsp;который произошел показ по&nbsp;Московскому времени в&nbsp;24-часовом формате.
          Пример: 01, 11, 22
        </>
      )
    },
    {
      id: getId(),
      label: '{{user_timezone}}',
      description: <>Временная зона пользователя, которому был сделан показ. Пример: +3</>
    },
    {
      id: getId(),
      label: '{{search_phrase}}',
      description: <>Поисковая фраза пользователя, которому был сделан показ</>
    },
    {
      id: getId(),
      label: '{{lead_form_id}}',
      description: <>id&nbsp;лид-формы</>
    },
    {
      id: getId(),
      label: '{{lead_form_name}}',
      description: <>Название лид-формы</>
    },
    {
      id: getId(),
      label: '{{ad_plan_id}}',
      description: <>id&nbsp;кампании, в&nbsp;которой используется лид-форма</>
    }
  ],
  myTarget: [
    {
      id: getId(),
      label: 'Параметр',
      description: <>Описание</>
    },
    {
      id: getId(),
      label: '{{advertiser_id}}',
      description: <>Идентификатор рекламодателя</>
    },
    {
      id: getId(),
      label: '{{campaign_id}}',
      description: <>Идентификатор рекламной кампании</>
    },
    {
      id: getId(),
      label: '{{campaign_name}}',
      description: <>Название рекламной кампании</>
    },
    {
      id: getId(),
      label: '{{banner_id}}',
      description: <>Идентификатор баннера</>
    },
    {
      id: getId(),
      label: '{{geo}}',
      description: <>Идентификатор региона, из&nbsp;которого кликнули по&nbsp;объявлению</>
    },
    {
      id: getId(),
      label: '{{gender}}',
      description: <>Пол пользователя, который кликнул по&nbsp;объявлению</>
    },
    {
      id: getId(),
      label: '{{age}}',
      description: <>Возраст пользователя, который кликнул по&nbsp;объявлению</>
    },
    {
      id: getId(),
      label: '{{random}}',
      description: (
        <>Случайное число. Часто используется в&nbsp;ссылках для более точного подсчета показов</>
      )
    },
    {
      id: getId(),
      label: '{{impression_weekday}}',
      description: <>День недели, в&nbsp;который произошел показ баннера</>
    },
    {
      id: getId(),
      label: '{{impression_hour}}',
      description: (
        <>
          Час, в&nbsp;который произошел показ. Указывается время по&nbsp;Москве в&nbsp;24-часовом
          формате
        </>
      )
    },
    {
      id: getId(),
      label: '{{user_timezone}}',
      description: <>Временная зона пользователя, который увидел объявление</>
    }
  ]
}

export const TitleData = {
  direct: 'Яндекс Директа',
  googleAds: 'Google Ads',
  vkAds: 'VK Реклама',
  myTarget: 'myTarget'
}

export const TabsData = [
  {
    label: 'Яндекс Директ',
    value: 'direct'
  },
  { label: 'Google Ads', value: 'googleAds' },
  {
    label: 'VK Реклама',
    value: 'vkAds'
  },
  {
    label: 'myTarget',
    value: 'myTarget'
  }
]

export const Features: { id: string; text: React.ReactNode; icon: Name }[] = [
  {
    id: getId(),
    text: (
      <>
        Оставляет только <br /> один знак вопроса
      </>
    ),
    icon: 'pen'
  },
  {
    id: getId(),
    text: <>Начинает каждый параметр метки с&nbsp;амперсанда</>,
    icon: 'thumb'
  },
  {
    id: getId(),
    text: <>Удаляет повторяющиеся протоколы сайта&nbsp;&mdash; http:// или https://</>,
    icon: 'trash'
  },
  {
    id: getId(),
    text: <>Автоматически заменяет символы, которые мешают аналитике</>,
    icon: 'magicWand'
  },
  {
    id: getId(),
    text: <>Экранирует (заменяет неподдерживаемые символы) или транслитерирует кириллицу</>,
    icon: 'instruments'
  },
  {
    id: getId(),
    text: <>Переводит заглавные буквы в&nbsp;строчные</>,
    icon: 'purpose'
  }
]
